// extracted by mini-css-extract-plugin
export var container = "navbar-module--container--b8886";
export var icon = "navbar-module--icon--21909";